import { jsx as _jsx } from "react/jsx-runtime";
import { SummaryCardWrapper } from './SummaryCard.style';
import AuxiliaryItem from './AuxiliaryItem';
import Header from './Header';
import Total from './Total';
const SummaryCard = ({ children, secondary }) => (_jsx(SummaryCardWrapper, { secondary: secondary, children: children }));
SummaryCard.Header = Header;
SummaryCard.Title = Header.Title;
SummaryCard.TitleAmount = Header.TitleAmount;
SummaryCard.AuxiliaryItem = AuxiliaryItem;
SummaryCard.Total = Total;
SummaryCard.TotalLabel = Total.TotalLabel;
SummaryCard.TotalAmount = Total.TotalAmount;
export default SummaryCard;
